import { vmap } from "../fn";
import { GqlError } from "./GqlError";
import { HttpError } from "./HttpError";

const BASE_HEADERS = {
	"Content-Type": "application/json",
	Accept: "application/json",
};

const parseResponse = res => (res.ok ? res.json() : Promise.reject(new HttpError(res)));

const throwGqlError = result => (result instanceof GqlError ? Promise.reject(result) : result);

const readData = ({ data, errors }) => (errors ? new GqlError(errors[0] || errors) : data);

export const gqlFetcher = (uri, baseHeaders, fetchFn = global.fetch) => (
	operation,
	{ headers, ...options } = {},
) =>
	fetchFn(uri, {
		method: "POST",
		...options,
		headers: { ...BASE_HEADERS, ...baseHeaders, ...headers },
		body: JSON.stringify(operation),
	})
		.then(parseResponse)
		.then(vmap(readData))
		.then(throwGqlError);
